/**
 * Was eine Rücknahme rechnet und meldet — ohne Oberfläche.
 *
 * `views/ruecknahme.js` hängt nur noch den Knopf daran. Die Schleife über die
 * Register, die Zählerei und beide Meldungen stehen hier, weil sie sich prüfen
 * lassen müssen: Die Meldung ist das Einzige, was der Benutzer von einer
 * abgelehnten Zeile je zu sehen bekommt.
 */

import { schreibeSammel } from './tabelle.js';

/** Die Meldung nach einem Sammelvorgang. */
export function ergebnisText({ geschrieben, fehler = [] }) {
  return fehler.length
    ? `${geschrieben} geschrieben, ${fehler.length} abgelehnt: ${fehler[0].text}`
    : `${geschrieben} geschrieben.`;
}

/**
 * Die Meldung nach einer Rücknahme.
 *
 * Nennt beides, was schiefgehen kann: übersprungene Sätze (seither von Hand
 * geändert) und abgelehnte (der Schreibweg hat sie zurückgewiesen). Eine
 * Ablehnung darf nie in einer freundlichen Zahl verschwinden — Hausregel:
 * protokollieren, weitermachen, am Ende berichten.
 */
export function ruecknahmeText({ zurueck, uebersprungen = 0, fehler = [] }) {
  const teile = [`${zurueck} zurückgenommen`];
  if (uebersprungen) teile.push(`${uebersprungen} übersprungen, seither geändert`);
  if (fehler.length) teile.push(`${fehler.length} abgelehnt: ${fehler[0].text}`);
  // Der Fehlertext bringt seinen eigenen Punkt mit; sonst stünden dort zwei.
  return fehler.length ? teile.join(', ') : `${teile.join(', ')}.`;
}

/**
 * Eine Rücknahme über alle beteiligten Register schreiben.
 *
 * Die Register nennt die Rücknahme selbst — zwei fest verdrahtete Namen
 * liessen Plätze, Reisen und Ausrüstung aussen vor.
 *
 * `wiederherstellung` ist die eine Stelle im ganzen Zweig, die sie setzt: Nur
 * die Rücknahme darf ein Importfeld wieder leeren, weil sie einen Stand
 * zurückschreibt, den `erwartet` soeben noch als unverändert bestätigt hat.
 */
export async function nimmZurueck(db, ruecknahme, optionen = {}) {
  const { erwartet, ...listen } = ruecknahme ?? {};
  let zurueck = 0;
  let uebersprungen = 0;
  const fehler = [];

  for (const [registerSchluessel, liste] of Object.entries(listen)) {
    if (!liste?.length) continue;
    const teil = await schreibeSammel(db, registerSchluessel, liste,
      { geraet: optionen.geraet, erwartet, wiederherstellung: true });
    zurueck += teil.geschrieben;
    uebersprungen += teil.uebersprungen;
    fehler.push(...teil.fehler);
  }
  return { zurueck, uebersprungen, fehler };
}
